import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

// Rend un graphique Chart.js d'évolution des visites à partir des données
// pré-calculées server-side (passées via data-matomo-chart-data-value).
export default class extends Controller {
  static targets = ["canvas"]
  static values = { data: Object }

  connect() {
    const { labels = [], visits = [], uniques = [] } = this.dataValue || {}
    if (!this.hasCanvasTarget || labels.length === 0) return

    this.chart = new Chart(this.canvasTarget, {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: "Visites",
            data: visits,
            borderColor: "#214F18",
            backgroundColor: "rgba(33, 79, 24, 0.15)",
            fill: true,
            tension: 0.3,
            pointRadius: 2
          },
          {
            label: "Visiteurs uniques",
            data: uniques,
            borderColor: "#f90c0b",
            backgroundColor: "rgba(249, 12, 11, 0.08)",
            fill: false,
            tension: 0.3,
            pointRadius: 2
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: "bottom" }
        },
        scales: {
          y: { beginAtZero: true, ticks: { precision: 0 } }
        }
      }
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
